import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.INTERFACE_MANAGEMENT.GIMAC.TRANSACTION_MENU;

const TransactionMenuLink: Array<LinkItemProps> = [
  {
    name: "Consultation des Transactions Valides",
    link: URL.CONSULTING_VALID_TRANSACTIONS,
    level: 3,
  },
  {
    name: "Consultation des Transactions GIMAC",
    link: URL.CONSULTING_GIMAC_TRANSACTIONS,
    level: 3,
  },
  {
    name: "Consultation des Settlements Valides",
    link: URL.CONSULTING_VALID_SETTLEMENTS,
    level: 3,
  },
];

export default TransactionMenuLink;
